import { load } from 'recaptcha-v3';
import { RECAPTCHA_VALIDATE_TOKEN } from '@/lib/api.js';
export default {
  data() {
    return {
      recaptcha: null,
      scoreLimit: 0.5
    };
  },

  mounted() {
    this.loadRecaptcha();
  },

  methods: {
    async loadRecaptcha() {
      try {
        this.recaptcha = await load(process.env.recaptchaSiteKey);
      } catch (e) {
        console.log('Error on loading recaptcha =>', e);
      }
    },
    async recaptchaCheck(action) {
      try {
        const recaptchaToken = await this.recaptcha.execute(action);

        const res = await this.$axios.post(RECAPTCHA_VALIDATE_TOKEN, {
          Token: recaptchaToken
        });

        if (!res || !res.data) {
          return false;
        }

        let success = res.data.Success;

        if (success) {
          return true;
        } else {
          console.log('Error on recaptcha =>', res.data['error-codes']);
          return false;
        }
      } catch (e) {
        console.log('Error on execute recaptcha =>', e);
        /** return true - not to prevent login/signup  */
        return true;
      }
    }
  }
};
